import { compose, withProps } from 'recompose';
import withSelfStorageSchema from '@sparefoot/react-core/decorators/withSelfStorageSchema';

export default compose(
	withProps(({ facility, baseUrl, cloudfrontUrl }) => {
		const { location, units, images, url, reviews } = facility;

		let schemaPromotion = [];
		const { smallUnit, mediumUnit, largeUnit } = units;
		if (smallUnit && smallUnit.special) {
			schemaPromotion = smallUnit.special;
		} else if (mediumUnit && mediumUnit.special) {
			schemaPromotion = mediumUnit.special;
		} else if (largeUnit && largeUnit.special) {
			schemaPromotion = largeUnit.special;
		}

		// Adding images, these are jpgs
		let imagesWithUrl = [];
		if (images && images.length) {
			imagesWithUrl = images.map(
				(image) => `https:${cloudfrontUrl}/medium-compress/${image}`,
			);
		}

		return {
			facility: {
				...facility,
				location: {
					...location,
				},
				imagesWithUrl,
				reviews: {
					...reviews,
				},
				schemaUrl: `${baseUrl}${url}`,
			},
			schemaPromotion,
		};
	}),
	withSelfStorageSchema,
);
